import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EliminarAgendaMasivaComponent } from './eliminar-agenda-masiva.component';

const routes: Routes = [
  { path: '', component: EliminarAgendaMasivaComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EliminarAgendaMasivaRoutingModule { }
